import React from "react";
import { Link } from "react-router-dom";


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const CtaSection = (props) => {
    return (
        <section className="wpo-cta-section mt-lg-4">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-8 col-md-6 col-12 ">
                        <div className="wpo-cta-text">
                            <span>
                                Наша компания предлагает услуги быстрой доставки.</span>
                            <p>
                                Мы понимаем, насколько важно своевременно получать и отправлять грузы, поэтому разработали специальные предложения для экспресс-доставки. Независимо от расстояния и сложности маршрута, мы гарантируем минимальные сроки доставки без ущерба для безопасности и качества

                                Наши логисты тщательно планируют каждый этап транспортировки, используя оптимальные маршруты и современные технологии отслеживания, чтобы ваш груз был доставлен точно в срок.
                            </p>
                        </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-6 col-12">
                        <div className="wpo-cta-btn">
                            <Link onClick={ClickHandler} className="theme-btn-s2" to="/contact">JOIN WITH US</Link>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    )
}
export default CtaSection;


